import React, {Component, Fragment} from 'react';
import {observer} from "mobx-react";
import ListSelector from "./ListSelector";
import axios from "axios";

class FullList extends Component {
  constructor(props) {
    super(props);
    this.state={
      inited:false,
      fields:[],
    };
  }
  componentDidMount() {
    axios.post(this.props.field.list_route,{ items_per_page:999999, page:1, order:{name:'asc'}, select:['id','name'] }).then((data)=>{
      this.setState({ fields: data.data.answer?data.data.answer.items:(data.data.items?data.data.items:[]), inited: true });
    });
  }

  inputRef(ref) {
    if(this.props.inputRef) {
      this.props.inputRef(ref);
    }
  }
  getLockedTitle() {
    const index=this.props.field.title_field?this.props.field.title_field:"name";
    const filtered=this.state.fields.filter((item)=>{
      return item.id == this.props.item.value;
    });
    if(filtered.length>0) {
      return filtered[0][index];
    }

    return this.props.item.value;

  }
  render() {
    /*if(!this.state.inited) {
      return "Загрузка...";
    }*/
    if(this.props.locked) {
      return this.getLockedTitle();
    }
    const addProps={};
    if(this.props.field.search_fields) {
      addProps.search_fields=this.props.field.search_fields;
    }
    if(this.props.field.visible_fields) {
      addProps.visible_fields = this.props.field.visible_fields;
    }
    return (
      <ListSelector
        relative={true}
        onBeforeChange={(e)=>{
          const arg=e.target.value.matchAll(/([<>=!~]?[><=]?)(.+)/gi).next();
          if(arg.value) {
            if(arg.value[2]) {
              if(arg.value[1] === '~' ||arg.value[1] === '=' || arg.value[1] === '!=' || arg.value[1] === '>' || arg.value[1] === '<' || arg.value[1] === '>=' || arg.value[1] === '<=') {
                this.props.item.compare=arg.value[1];
                e.target.value=arg.value[2];
              }
            }
          }
        }}
        inputRef={(ref)=>{ this.inputRef(ref); }}
        idField={"id"}
        titleField={this.props.field.title_field?this.props.field.title_field:"name"}
        fields={this.state.fields}
        fetching={!this.state.inited}
        onNewFied={()=>{
          this.props.onNewFied();
        }}
        onSelectId={(id)=>{
          this.props.item.value=id;
          this.props.item.focus = 1;
        }}
        onLock={()=>{
          if(this.props.onLock) {
            this.props.onLock();
          }
        }}
        onCancel={()=>{
          this.props.onCancel();
        }}
        onSelect={(item)=>{
          if(item) {
            this.props.item.value = item.id;
            this.props.item.focus = 1;
          } else {
            this.props.item.value = '';
          }
        }}
        selected_value={this.props.item.value}
        {...addProps}
      />
    )
  }
}

export default observer(FullList);